<div class="app-shell">
  <header class="app-header">
    <a class="brand" routerLink="/landing" aria-label="Arcane Legion home">
      <img
        src="assets/images/app-icon.png"
        alt=""
        class="brand-icon"
      />

      <span>
        <strong>Arcane Legion</strong>
        <small>Fantasy RPG • Card PvP</small>
      </span>
    </a>

    <nav class="nav-links" aria-label="Main navigation">
      @for (link of navLinks; track link.path) {
        <a
          [routerLink]="link.path"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: link.path === '/landing' }"
        >
          {{ link.label }}
        </a>
      }
    </nav>

<!--    <a class="nav-cta" routerLink="/heroes">Begin Your Legion</a>-->
    <button type="button" class="nav-cta" (click)="beginLegion()">
      Begin Your Legion
    </button>
  </header>

  <router-outlet />

  <app-development-notice />
</div>
